import React from 'react';

import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import CircularProgress from '@mui/material/CircularProgress';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';

import PrestaGlobals from '../common/PrestaGlobals';

/**
 * Admin: switches to a fresh, empty cart (new id). The old cart is only abandoned, it stays in the DB.
 * Full page reload so the designer and Unity start clean on the new cart.
 */
const NewCartButton: React.FC = () => {
    const [busy, setBusy] = React.useState(false);
    const [error, setError] = React.useState<string | null>(null);

    const create = async () => {
        setBusy(true);
        setError(null);
        const url = PrestaGlobals.cartUrl('newcart');
        try {
            const data = await (await fetch(url)).json();
            if (!data.id_cart) throw new Error(data.error ?? 'Nem sikerült új kosarat létrehozni.');
            // Pending session cart would be merged into the new cart on the cart page
            try { localStorage.setItem('ucjsonstamp', 'false'); } catch { /* storage blocked */ }
            window.location.replace(window.location.pathname);
        } catch (e) {
            setBusy(false);
            setError(e instanceof Error ? e.message : String(e));
        }
    };

    return (
        <Tooltip title={error ?? 'Új, üres kosár (a régi megmarad)'}>
            <span>
                <Button size="small" color={error ? 'error' : 'primary'} disabled={busy}
                    startIcon={busy ? <CircularProgress size={14} /> : <AddShoppingCartIcon />} onClick={create}>
                    Új kosár
                </Button>
            </span>
        </Tooltip>
    );
};

export default NewCartButton;
